import get from 'lodash/get';

import { REQUEST_DASHBOARD } from '../actionConstants';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_DASHBOARD:
      return get(action, 'payload.data', {});
    default:
      return state;
  }
};
